import React from 'react'
import { useNavigate } from 'react-router'
import Container from 'components/Container'
import { ROUTES_PATHS } from 'const'

import styles from '../styles/product.module.scss'

const ProductNotFound = () => {
  const navigate = useNavigate()

  const handleGoToCatalog = () => {
    navigate(ROUTES_PATHS.MAIN)
  }

  return (
    <Container>
      <div className={styles.product__not_found}>
        <span className={styles.product__not_found__title}>
          Товар не найден 
        </span>

        <button
          className={styles.product__not_found__button}
          onClick={handleGoToCatalog}
        >
          Вернуться в каталог
        </button>
      </div>
    </Container>
  )
}

export default ProductNotFound